module.exports = __webpack_public_path__ + "img/modal-purchase-null.3e081f08.svg";